import { useState } from 'react';
import Image from 'next/image';
import { ENDPOINTS } from '@/config/endpoints';
import dynamic from 'next/dynamic';
import { FormProvider } from '@/component/shared/contactForm/formContext';
import Head from 'next/head';
import BreadCrumb from '@/component/shared/breadCrumb';


const ContactFormStep1 = dynamic(() => import('@/component/shared/contactForm/contactFormStep1'), {
  loading: () => <p>Loading...</p>})
const ContactFormStep2 = dynamic(() => import('@/component/shared/contactForm/contactFormStep2'), {
    loading: () => <p>Loading...</p>})


const EventsDetail = ({post,paraUrl}) => {
  const [showNextStep, setShowNextStep]= useState(false)
    // const router = useRouter;
    const pathName = process.env.URL+paraUrl;
   
  const showSteps=()=>{
      setShowNextStep(true)
  }
  const showFirstStep=()=>{
    setShowNextStep(false)
  }
  const dateFormat = (publishDate)=>{
    const dateString = new Date(publishDate);
    const options = { day:'numeric', year: 'numeric', month: 'short' };
    if (typeof dateString === 'object' && dateString !== null && 'toLocaleDateString' in dateString) {
      const result = dateString.toLocaleDateString('en-US',options);
      return <span>{result}</span>
    }
  }

  
  const cleanedContent = post.content.rendered ? post.content.rendered
  .replace(/\[vc_row[^\]]*]/g, '') // Replace [vc_row]
  .replace(/\[vc_column[^\]]*]/g, '') // Replace [vc_column]
  .replace(/\[vc_single_image[^\]]*]/g, '') // Replace [vc_single_image]
  .replace(/\[vc_row_inner[^\]]*]/g, '') // Replace [vc_row_inner]
  .replace(/\[vc_column_inner[^\]]*]/g, '') // Replace [vc_column_inner]
  .replace(/\[vc_empty_space[^\]]*]/g, '') // Replace [vc_empty_space]
  .replace(/\[vc_raw_html[^\]]*]\[[^\]]*]/g, '') // Replace [vc_raw_html] along with its content
  .replace(/\[\/vc_column_text\]/g, '') // Replace [/vc_column_text]
  .replace(/\[\/vc_column_inner\]/g, '') // Replace [/vc_column_inner]
  .replace(/\[\/vc_row_inner\]/g, '') // Replace [/vc_row_inner]
  .replace(/\[\/vc_column\]/g, '') // Replace [/vc_column]
  .replace(/\[\/vc_row\]/g, '') // Replace [/vc_row]
  .replace(/\[vc_widget_sidebar[^\]]*]/g, '') // Replace [vc_widget_sidebar]
  .replace(/\[vc_custom_heading[^\]]*]/g, '')
  .replace(/\[vc_raw_html[^\]]*]\[[^\]]*]/g, '') // Remove [vc_raw_html] along with its content
  .replace(/\[vc_raw_html]JTVCc21hcnRfcG9zdF9zaG93JTIwaWQlM0QlMjIxMDAwNSUyMiU1RA==\[\/vc_raw_html]/g, ''): post.content.rendered ;

  const htmlString = post.yoast_head ?post.yoast_head :'';
  // Define a regular expression to match the og:description meta tag
  const regex = /<meta\s+property="og:description"\s+content="([^"]+)"\s*\/>/;
  // Use the regex to extract the content
  const match = htmlString.match(regex);
  // Extracted description
  const description = match ? match[1] : null;

  const decodeHtml = (html) => {
    if (!html) return '';
    if (typeof document !== 'undefined') {
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    }
    return html
      .replace(/&#(\d+);/g, (_, dec) => String.fromCharCode(dec))
      .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => String.fromCharCode(parseInt(hex, 16)))
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/&nbsp;/g, ' ');
  };

  return (
    <main className='mt-[100px]'>
      <Head>  
          <title>{post.title.rendered}</title>
          <meta name="description" content={description} />
          {/* OpenGraph tags */} 
          <meta property="og:title" content={post.title.rendered}/>
          <meta property="og:description" content={description} />
          <meta property="og:image" content={post._embedded['wp:featuredmedia'][0].source_url} />
          <meta property="og:url" content={pathName} />
          <link rel="canonical" href={pathName} />
        </Head>
    {post !=null &&
       <section className='py-sp-small sm:pt-3'>
        <BreadCrumb parentPage={'Events'} parentSlug={'events'} page={decodeHtml(post.title.rendered)} />
       <div className='container pt-4 lg:px-3  x-3 xm:px-3 '>
           <div className="flex flex-wrap">
              <div className="w-[62%] pr-[40px] sm:pr-0 md:w-full sm:w-full">
                <p className='text-sm text-[#7b7b7b] mb-1 sm:pt-10 md:pt-10'><span className='font-medium text-black'>Published : </span>{dateFormat(post.date)}, <span className='font-medium text-black'>Updated : </span>{dateFormat(post.modified)}</p>
                      <h1 className="lg:text-heading1 sm:text-xxl text-heading2 text-secondary font-semibold pb-[50px] sm:pb-10">{post.title.rendered}</h1>                
                      {post._embedded && post._embedded['wp:featuredmedia'] && (
                            <Image className='w-full h-auto' priority
                              src={post._embedded['wp:featuredmedia'][0].source_url} alt={post.title.rendered} width={1200} height={628}
                            />
                      )}
                       <div className='blog-content' dangerouslySetInnerHTML={{ __html: post.content.rendered }}></div>
              </div>
              <div className="w-[38%] md:w-full sm:w-full md:mt-4 sm:mt-4">
                    <div className='lg:sticky xm:sticky lg:top-[150px] xm:top-[120px]'>
                      <div className='mb-5'>
                      <FormProvider>
                      {!showNextStep ?
                      <ContactFormStep1 showStep1={showSteps} />:
                        <ContactFormStep2 showPrevStep={showFirstStep} formType="GetInTouchNew"  />
                      }
                      </FormProvider>
                      </div>
                    </div>
                </div>
            </div>
            
       </div> 
   </section>
    } 
 </main>
  );
};

export default EventsDetail;


export async function getServerSideProps(context) {
  // Fetch data from an API or database
  const { req,res } = context;
  const paraUrl = context.resolvedUrl || null
  const paramSlug = paraUrl.replace(/^\/events\//, '');
  let postId = '';
  let postData = '';

  try {
    const response = await fetch(ENDPOINTS.WORDPRESS_MAIN_API+`?_embed&slug=${paramSlug}`); // Replace with your WordPress API endpoint URL
    const data = await response.json();
    if (data.length > 0) {
      postId = data[0].id;
    }else{
      res.statusCode = 404;
      return{
        notFound: true,
      }
    }
  } catch (error) {
    console.error('Error:', error);
    res.statusCode = 500;
    return {
      notFound: true,
    };
  }
  if (postId) {
      try {
        const response = await fetch(ENDPOINTS.WORDPRESS_MAIN_API+`/${postId}?_embed`); // Replace with your WordPress API endpoint URL
        const data = await response.json();
        postData = data;
        
      } catch (error) {
        console.error('Error:', error);
        res.statusCode = 500;
        return {
          notFound: true,
        };
      }
  }

  // Return the data as props
  return {
    props: {
      post:postData,
      paraUrl
    },
  };
}